import React from 'react';
import classnames from 'classnames';
import { useHistory } from 'react-router-dom';
import { translate } from 'constants/language';
import { BrowserView } from 'react-device-detect';
import { CURRENT_LANG_PREFIX } from '../../../constants';

export default ({ title = "", icon, link, title2 = "", icon2, link2 = "", rightCTA, is2ndActive = false, noBottomGap = false }) => {

  const history = useHistory();
  const openLink = path => {
    if (typeof path !== "undefined")
      return history.push(`/${CURRENT_LANG_PREFIX}/account/${path}`);
    return false;
  };
  return (
    <BrowserView>
      <div className="flex top-xs pt-24">
        <div className="ml-0 mr-auto flex middle-xs">
          <div
            className={classnames("flex middle-xs pb-24", { "fw-6": title2 === "", "o-50 fw-5": is2ndActive && title2 !== "", "fw-6 bb-brand mb-n-1": !is2ndActive && title2 !== "", "cursor-default": typeof link === "undefined" })}
            onClick={() => openLink(link)}
            onKeyPress={() => openLink(link)}
            role="link"
          >
            <If condition={icon}><div className="pr-r-10 flex middle-xs">{icon}</div></If>
            <div className="fs-16 lh-20 ls-048">{translate(title)}</div>
          </div>
          <If condition={title2 !== ""}>
            <div
              className={classnames("flex middle-xs pb-24 ml-r-40", is2ndActive ? "fw-6 bb-brand mb-n-1" : "fw-5 o-50")}
              onClick={() => openLink(link2)}
              onKeyPress={() => openLink(link2)}
              role="link"
            >
              <If condition={icon2}><div className="pr-r-10">{icon2}</div></If>
              <div className="fs-16 lh-20 ls-048">{translate(title2)}</div>
            </div>
          </If>
        </div>
        <If condition={rightCTA}>
          <div className="mr-0 ml-auto">
            {rightCTA}
          </div>
        </If>
      </div>
      <hr className={classnames("mt-0", noBottomGap ? "mb-0" : "mb-24")} />
    </BrowserView>
  );
};
